<template>
  <div class="input-container">
    <DsTextarea
      v-model="message"
      :disabled="isLoading"
      @keypress="handleKeyPress"
      placeholder="Type your message..."
      class="input-textarea"
      is-simplified
      :autoresize="false"
      style="width: 100%; min-height: 60px; max-height: 75px;"
    />
    <div class="input-actions">
      <div class="global-search__userBack">
        <a @click="openFeedbackWindow">Give us feedback</a>
      </div>

      <button class="send-btn" @click="sendMessage" :disabled="!message.trim() || isLoading">
        <Icon name="send"/>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { openFeedbackWidget } from '@/util/feedback-widget'
  import DsTextarea from '@/components/Form/DsTextarea.vue'
  import Icon from '@/components/Icon/Icon.vue'

  export default defineComponent({
    name: 'ConversationalAgentInput',
    components: { DsTextarea, Icon },
    props: {
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        message: ''
      }
    },
    methods: {
      handleKeyPress(e: KeyboardEvent) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          this.sendMessage()
        }
      },
      sendMessage() {
        const trimmed = this.message.trim()
        if (!trimmed || this.isLoading) return

        this.$emit('send-message', trimmed)
        this.message = ''
      },
      openFeedbackWindow() {
        openFeedbackWidget()
      }
    }
  })
</script>

<style scoped lang="scss">
  .input-container {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 1rem;

    .input-textarea {
      border: none;
      resize: none;
      width: 100%;
      min-height: 60px;

      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px #BEA6FF;
      }
    }

    .input-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px solid #eee;

      .global-search__userBack {
        a {
          cursor: pointer;
          color: #BEA6FF;

          &:hover {
            text-decoration: underline;
            color: #843DFF;
          }
        }
      }

      .send-btn {
        background-color: #843DFF;
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 6px;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover:not(:disabled) {
          background-color: #D9CEFF;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
